import React, { useRef, useState, useEffect } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";

const useStyles = makeStyles((theme: any) => ({
  searchPaper: {
    display: "flex",
    border: "solid 1px #e4e4e6",
    backgroundColor: theme.colours.white,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  buttomWithoutRadious: {
    borderRadius: "5px",
  },
  searchPaperBottomSquared: {
    display: "flex",
    alignItems: "center",
  },
  input: {
    display: "flex",
    flex: 1,
    fontSize: 12,
    fontWeight: 600,
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "1.25",
    letterSpacing: "normal",
    textAlign: "left",
    color: theme.colours.grey900,
    paddingLeft: "8px",
  },
  iconSearch: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    paddingRight: 10,
    color: theme.colours.brownGrey2,
  },
  iconButton: {
    color: theme.colours.violeta,
    padding: 0,
  },
}));

export type SearcherChangeEvent = { target: { value: string } };

export interface SearcherProps {
  filter: string;
  onChange?: (event: SearcherChangeEvent) => void;
  onClear?: () => void;
  placeholder?: string;
  borderBottomRounded?: boolean;
  borderSquared?: boolean;
  value?: string;
}

const Searcher: React.FC<SearcherProps> = ({
  filter,
  onChange,
  onClear,
  placeholder,
  borderBottomRounded = true,
  borderSquared,
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [value, setValue] = useState<string>(filter);

  useEffect(() => {
    setValue(filter);
  }, [filter]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const handleClickEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (onChange && event.key === "Enter") onChange({ target: { value } });
  };

  const handleBlur = () => {
    onChange?.({ target: { value } });
  };

  const handleClear = () => {
    setValue("");
    onClear?.();
  };

  const classes = useStyles();
  const filtering = !!value && value.length > 0;

  return (
    <div
      style={borderSquared ? { borderRadius: "5px" } : { borderRadius: "20px" }}
      className={
        filtering || !borderBottomRounded
          ? [classes.searchPaper, classes.searchPaperBottomSquared].join(" ")
          : classes.searchPaper
      }
    >
      <InputBase
        inputRef={inputRef}
        className={classes.input}
        placeholder={placeholder}
        onBlur={handleBlur}
        value={value}
        onChange={handleChange}
        onKeyDown={handleClickEnter}
      />
      {filtering && (
        <IconButton className={classes.iconButton} onClick={handleClear}>
          <Close />
        </IconButton>
      )}
      <div
        onClick={() => inputRef.current?.focus()}
        className={classes.iconSearch}
      >
        <SearchIcon />
      </div>
    </div>
  );
};

export default Searcher;
